import {Action, createReducer, on} from '@ngrx/store';
import {ManufacturerEntity} from './manufacturer.models';
import {Exception} from '../../../../../../core/models';
import {ManufacturerActions} from './manufacturer.actions';
import {AuthenticationActions} from '../../../authentication-store/src/+state/authentication.actions';

export const MANUFACTURER_FEATURE_KEY = 'manufacturer';

export interface ManufacturerState {
  isLoading: boolean;
  items: ManufacturerEntity[];
  exception: Exception;
}

export interface ManufacturerPartialState {
  readonly [MANUFACTURER_FEATURE_KEY]: ManufacturerState;
}

export const initialState: ManufacturerState = {
  isLoading: false,
  exception: null,
  items: []
};


export const manufacturerReducer = createReducer(
  initialState,

  on(ManufacturerActions.loadManufacturersRequest, state => ({
    ...state,
    isLoading: true,
  })),
  on(ManufacturerActions.loadManufacturersSuccess, (state, {payload}) => ({
    ...state,
    isLoading: false,
    items: payload.items
  })),
  on(ManufacturerActions.loadManufacturersFailure, (state, {exception}) => ({
    ...state,
    isLoading: false,
    exception
  })),
  on(AuthenticationActions.clearSession, () => initialState),
);

export function reducer(state: ManufacturerState | undefined, action: Action) {
  return manufacturerReducer(state, action);
}
